import { formatPrice } from "@/lib/formatPrice";

interface ProductItem {
  id: number;
  name: string;
  sku: string | null;
  count: number;
  revenue: number;
}

interface DashboardTopProductsProps {
  products: ProductItem[];
}

export default function DashboardTopProducts({ products }: DashboardTopProductsProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60">
      <div className="px-5 py-3 border-b border-border/60">
        <p className="text-sm font-semibold">Najprodavaniji proizvodi</p>
      </div>
      <div className="divide-y divide-border/60">
        {products.length === 0 ? (
          <p className="px-5 py-4 text-sm text-muted-foreground">Nema podataka</p>
        ) : (
          products.map((product) => (
            <div
              key={product.id}
              className="px-5 py-2.5 text-sm flex items-center gap-3"
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{product.name}</p>
                <p className="text-muted-foreground text-xs">{product.sku ?? "—"}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="tabular-nums">{product.count} kom</p>
                <p className="text-muted-foreground tabular-nums text-xs">
                  {formatPrice(product.revenue)} KM
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
